/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { ExtendedUser } from './ExtendedUser';
import { SessionRestrictionData } from './SessionRestrictionData';
const ResultDataPostLoginLinkLoginParser = 
/* #__PURE__ */ parsers.object([
    ['user', ExtendedUser],
    ['accessToken', codecString, 'access_token'],
    ['restrictions', SessionRestrictionData],
    ['expiresAt', parsers.moment, 'expires_at'],
]);
export class ResultDataPostLoginLinkLogin extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return ResultDataPostLoginLinkLoginParser.decode(input).map(res => new ResultDataPostLoginLinkLogin(res));
    }
    static unsafeDecode(input) {
        return ResultDataPostLoginLinkLogin.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return ResultDataPostLoginLinkLoginParser.encode(data);
    }
    static schema() {
        return ResultDataPostLoginLinkLoginParser.schema();
    }
}
